/* @ngInject */
function HomeController ($scope, $rootScope, $location, $translate, $q, $timeout, $state, HomeService, SegmentService, UdsModalService, AdminService, MessageService, IntercomService, CampaignInitialOnboardingService, UiElementViewLogService) {
  const getInviteTeamMembersDialogController = () => $q.when(import('../admin/dialogs/invite-team-members/invite-team-members-dialog.controller'))
  const getRequestDetailsDialogController = () => $q.when(import('../workflow/dialogs/request-details/request-details-dialog.controller'))

  $scope.flags = {
    noInsightsData: false
  }
  $scope.tasks = []

  const api = {
    getInviteTeamMembersDialogController,
    getRequestDetailsDialogController,
    _handleSuccessGetCampaigns,
    _handleSuccessGetTasks,
    _handleSuccessGetPosts,
    _openInviteUserModal,
    _showUserQuotaError,
    _openRequestDetailDialog,
    _showCampaignOnboarding
  }
  this.getApi = () => api

  $scope.headerNavigation = {}

  activate()

  function activate () {
    api._showCampaignOnboarding()
    SegmentService.track('general-portal-pageview')

    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      $scope.features = features
      $scope.isTwoColumns = ($scope.features['WORKFLOW.ACCESS'] || $scope.features['POSTS.ACCESS']) && $rootScope.isDesktop
    })

    $rootScope.getUser().then(user => {
      api._showCampaignOnboarding(user)
    })

    HomeService.getHomeCampaigns(7).then(api._handleSuccessGetCampaigns)
    HomeService.getTasks(3).then(api._handleSuccessGetTasks)
    HomeService.getHomePosts(5).then(api._handleSuccessGetPosts)

    if ($location.search().chat === 'open') {
      IntercomService.show()
    }

    $timeout(() => {
      if ($rootScope.isUserSysAdminAdmin()) {
        $scope.headerNavigation = {
          buttons: [{
            type: 'button',
            btnType: 'primary',
            label: $translate.instant('invite'),
            icon: 'user-plus',
            onClick: api._openInviteUserModal
          }]
        }
        $rootScope.getUserCompany().then(company => {
          AdminService.getActiveUsers(company.id)
            .then(res => {
              $scope.activeUsers = res
            })
        })
      }
    }, 800)
  }

  $translate.onReady(() => {
    $scope.homeTitle = $translate.instant('home')
  })

  const deregisterOpenRequestDetailsDialog = $scope.$on('home.openRequestDetailsDialog', ($event, { taskId }) => {
    api._openRequestDetailDialog(taskId)
  })

  $scope.$on('$destroy', () => {
    deregisterOpenRequestDetailsDialog()
  })

  function _handleSuccessGetCampaigns (campaigns) {
    if (campaigns.rows.length) {
      $scope.campaigns = campaigns.rows
    }
  }

  function _handleSuccessGetTasks (tasks) {
    $scope.tasks = tasks
  }

  function _handleSuccessGetPosts (posts) {
    $scope.posts = posts.rows
  }

  function _openInviteUserModal () {
    if (!$rootScope.isUserSysAdminAdmin()) return
    if (parseInt($scope.activeUsers) >= $rootScope.oUserCompany.maxLicenses) {
      api._showUserQuotaError()
      return
    }

    getInviteTeamMembersDialogController().then(({ InviteTeamMembersDialogController }) => {
      const inviteTeamMembersDialog = UdsModalService.createModal({
        controller: InviteTeamMembersDialogController,
        modalName: 'inviteTeamMembersDialog',
        onClose: (dialogResponse) => {
          if (dialogResponse) {
            $state.go('admin.users')
          }
        }
      })

      inviteTeamMembersDialog.open()
    })
  }

  function _showUserQuotaError () {
    MessageService.warning({
      title: $translate.instant('activeUsersQuotaErrorTitle'),
      text: $translate.instant('usersMaximumReached')
    })
  }

  function _openRequestDetailDialog (id) {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        }
      })
      modal.open()
    })
  }

  function _showCampaignOnboarding (user) {
    const onClose = () => {
      UiElementViewLogService.createElementViewLog('campaign-initial-onboarding-dialog')
    }

    if ($rootScope.isUserSysAdminAdmin(user)) {
      UiElementViewLogService.getElementViewLog('campaign-initial-onboarding-dialog').then((elementViewLog) => {
        if (elementViewLog) return
        CampaignInitialOnboardingService.openDialog(onClose)
      })
    }
  }
}

export { HomeController }
